import script from "./UpdatePaymentMethod.vue?vue&type=script&setup=true&lang=js"
export * from "./UpdatePaymentMethod.vue?vue&type=script&setup=true&lang=js"

import "./UpdatePaymentMethod.vue?vue&type=style&index=0&id=3b9b454c&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b9b454c"]])

export default __exports__